<template>
  <div class="d-flex flex-column full-height">
    <div class="flex-column">
      <div class="d-flex text-h4">{{ config.title }}</div>
      <div class="d-flex text-h6">{{ config.subtitle }}</div>
    </div>

    <div class="text-h1 d-flex flex-grow-1 justify-center align-center" style="font-size: 150px">{{ count }}</div>
    <div class="full-width d-flex flex-grow-1 align-end">
      <v-btn class="ml-auto" dark text @click.stop="$router.push(config.link)">öffnen</v-btn>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import configMixin from '@/mixins/configMixin';
import index from '@/modules/customerVbzWorksheet/index';
import worksheetService from '@/modules/customerVbzWorksheet/worksheetService';
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';

export default {
  name: 'DispoWidget',
  mixins: [configMixin, wsMixin],
  props: {
    config: Object,
  },
  computed: {
    ...mapState('vbzWorksheet', ['absences', 'absencesByDate']),
    ...mapState('profile', ['user']),

    moduleConfig() {
      return this.getModuleConfig(index.moduleType);
    },

    count() {
      return this.mx_notCompletedAbsencesAtGivenDate(new Date()).length;
    },
  },
};
</script>
